import Api from "./componentApi";

const setLocalDeliveryData = (jsonData, callback) => {
  if (
    // eslint-disable-next-line
    __isBrowser__ &&
    typeof localStorage !== "undefined"
  ) {
    localStorage.setItem("deliveryDetails", jsonData);

    if (localStorage.getItem("deliveryDetails")) {
      Api.post("/api/cache/delivery", { jsonData }, (response, errors) => {
        if (errors) {
          if (errors === 503) {
            this.setState(() => {
              throw errors;
            });
          } else {
            console.log(errors);
          }
        } else {
          if (response.status) {
            callback();
          }
        }
      });
    }
  }
};

export default setLocalDeliveryData;
